import {css} from 'lit';
export const styles = css`img{max-width:100%}`;
export default styles;
